import { __decorate } from "tslib";
// deep imports to fix circular deps in jest
import { AppRequest } from '../../app-request';
import { Model, ModelId } from '../../model';
import { AppRequestMethod } from '../../request';
let EndSessionRequest = /*#__PURE__*/(() => {
  let EndSessionRequest = class EndSessionRequest extends Model {};
  EndSessionRequest = __decorate([AppRequest('access', 'session/end', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("EndSessionRequest") // auto-generated by generate-model-ids
  ], EndSessionRequest);
  return EndSessionRequest;
})();
export { EndSessionRequest };